import { Box, keyframes, styled } from '@mui/material'
import { getColorByScore } from './processes'

interface ProgressBarSegmentProps {
	color: string
	width: number
}

const fadeIn = (props: ProgressBarSegmentProps) => keyframes`
  from {
    width: 0%;
  }
  to {
    width: calc(0% + ${props.width}%);
  }
`

const ProgressBar = styled(Box)({
	width: '100%',
	height: '12px',
	backgroundColor: 'transparent',
	borderRadius: '2px',
	overflow: 'hidden',
	display: 'flex',
})

const ProgressBarSegment = styled(Box)<ProgressBarSegmentProps>(
	{
		height: '100%',
		width: '0%',
	},
	props => ({
		backgroundColor: props.color,
		animation: `${fadeIn(props)} 0.5s ease-in-out forwards`,
		animationFillMode: 'forwards',
	}),
)
export interface IDotsInfoLinearChart {
	segmentValue: number
	score?: string | number
	color?: string
}
export interface ILinearChart {
	dotsInfo: IDotsInfoLinearChart[]
	totalCount: number
}
const LinearChart = (props: ILinearChart) => {
	const { dotsInfo = [], totalCount } = props

	const isEmpty =
		!dotsInfo ||
		dotsInfo.length === 0 ||
		totalCount === 0 ||
		dotsInfo.every(el => el.segmentValue === 0)

	if (isEmpty) {
		return (
			<ProgressBar>
				<ProgressBarSegment color={'#F7F7F7'} width={100} />
			</ProgressBar>
		)
	}

	const progressBarSegments = dotsInfo?.map((el, index) => {
		const categorySum = el.segmentValue
		const percentRaw = (categorySum / totalCount) * 100
		const percent = Math.max(
			0,
			Math.min(100, Number.isFinite(percentRaw) ? percentRaw : 0),
		)
		const color = el.color ? el.color : getColorByScore(el.score)
		return (
			<ProgressBarSegment
				key={`${el.segmentValue} - ${index}`}
				color={color}
				width={percent}
			/>
		)
	})

	return <ProgressBar>{progressBarSegments}</ProgressBar>
}

export default LinearChart
